import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogLinkEquipmentComponent, DialogLinkEquipmentData, DialogLinkEquipmentResult } from './dialog-link-equipment.component';


@Injectable({
  providedIn: 'root'
})
export class LinkEquipmentDialogService {
  constructor(private matDialog: MatDialog) {}

  public open({ locationEnvironmentId, locationId, locationSectorId }: DialogLinkEquipmentData): Promise<DialogLinkEquipmentResult> {
    return this.matDialog.open<DialogLinkEquipmentComponent, DialogLinkEquipmentData, DialogLinkEquipmentResult>(DialogLinkEquipmentComponent, {
      panelClass: 'dialog-link-equipment',
      autoFocus: false,
      data: {
        locationEnvironmentId,
        locationId,
        locationSectorId
      }
    }).afterClosed()
      .toPromise();
  }
}
